import { useEffect, useState } from "react";
import Headers from "../../Components/HeaderPrivate";
import FooterTransparent from "../../Components/footerTransparente";
import Spinner from "../../Components/Spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import API_URL from "../../const";
import Toast from "../../Components/Toast/Toast";
import ToastError from "../../Components/Toast/ToastError";
import ToastInfo from "../../Components/Toast/ToastInfo";

function Newsletter() {

  const [activeTab, setActiveTab] = useState(0);  
  const navigate = useNavigate();
  const token = localStorage.getItem("token");    
  const [error, setError] = useState(null);
  const [IsOpenSpinner, setIsOpenSpinner] = useState(false);  
  const [showPassword, setShowPassword] = useState(false);
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showToastError, setShowToastError] = useState(false);
  const [msg, setMsg] = useState("");
  const [contactInfo, setContactInfo] = useState({
    token: "",
    contrasenia: "",
    confirmPassword: "",

  });

  const resetToasts = () => {
    setShowToast(false);
    setShowToastError(false);
    setError(null);
  };
   

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const validateForm = (e) => {
    e.preventDefault();
    const match = contactInfo.contrasenia === contactInfo.confirmPassword;

    setPasswordsMatch(match);

    if (!match) {
      return; // Las contraseñas no coinciden, no puedes enviar el formulario
    }

    handleSubmit(e); // Las contraseñas coinciden, puedes enviar el formulario
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    
    setContactInfo(prevContactInfo => {
      const newContactInfo = { ...prevContactInfo, [name]: value };
      
      if (newContactInfo.contrasenia && newContactInfo.confirmPassword) {
        setPasswordsMatch(newContactInfo.contrasenia === newContactInfo.confirmPassword);
      } else{
        //Si algún campo está vacío, se considera que las contraseñas no coinciden
        setPasswordsMatch(false);
      }
      return newContactInfo;
    });
  };

  const handleSubmit = async (e) => {
    setIsOpenSpinner(true);
    e.preventDefault();

    const formDataToSend = new FormData();
      formDataToSend.append('token', token);
      formDataToSend.append('contrasenia', contactInfo.contrasenia);
    
    /*console.log("Cuerpo de la solicitud:", requestBody);*/

    try {
      const response = await fetch(`${API_URL}updatePasswordUsario.php`, {
        method: "POST",
        body: formDataToSend,
      });

      const text = await response.text();
      const startIndex = text.indexOf("[{");
      const jsonResponse = (startIndex !== -1) ? text.substring(startIndex) : text;
      const responseData = JSON.parse(jsonResponse);
      

      if (response.ok) {
        
        setMsg("Usuario actualizado correctamente");
        setShowToast(true);
        setIsOpenSpinner(false);

        setTimeout(() => {
          setShowToast(false);
        }, 5000);

        
        
      } else {
        console.error("Error del servidor:", response.statusText);
        resetToasts();
        setError(response.statusText || "Error desconocido");
        setMsg(responseData.message || "No se pudo actualizar la contraseña");
        setShowToastError(true);
        setIsOpenSpinner(false);
        setTimeout(() => setShowToast(false), 5000);
        setTimeout(() => setShowToastError(false), 5000);
      }

    } catch (error) {
      console.error("Error en la solicitud:", error.message);
      resetToasts();
      setError("Error de red: " + error.message);
      setMsg("Error de red: " + error.message);
      setShowToastError(true);
      setIsOpenSpinner(false);
      setTimeout(() => setShowToast(false), 5000);
      setTimeout(() => setShowToastError(false), 5000);
    }
  };

  useEffect(() => {

    if(token==null || token == undefined || token == ""){
      navigate("/login");
    }
    
  }, [])

  return (
    <section className=" w-full absolute left-0 right-0 bottom-0 top-0">
      <Headers />
      <Spinner isOpen={IsOpenSpinner}></Spinner>{" "}
      {showToast && (
        <Toast isOpen={true} title="Éxito" text={msg} />
      )}{" "}
      {showToastError && <ToastError isOpen={true} title="Error" text={msg} />}{" "}
      <div className="pb-10 pt-24 px-5 bg-gray-100">
        <div className="xl:flex block">
          <div className=" w-full bg-white border m-0 rounded-lg  p-2 md:p-4">

            <Tabs onSelect={(index) => {
              setActiveTab(index)
            }} selectedIndex={activeTab}  >
              <TabList style={{ display: "flex", justifyContent: "center", listStyle: "none" }}>
                <Tab style={{ width: "50%", textAlign: "center", cursor: "pointer" }}>
                  <label class="justify-center cursor-pointer items-center flex">
                    <box-icon type="solid" name="lock" size="sm" ></box-icon> Cambiar mi contraseña
                  </label>
                </Tab>

              </TabList>
              <TabPanel>


                <div className="w-full pl-2 pr-2">
                  <div className="flex justify-center mt-10 w-full tamanoConenedor scrollbar styleScrollbar">
                    <div className="w-full card-login  rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0  max-w-[70%] z-10">
                      <div className="ml-5 mr-5 mb-5 mt-2 pt-5">
                        <form onSubmit={validateForm}>


                          <div className="relative z-0 w-full mb-5 group">
                            <label
                              htmlFor="contrasenia"
                              className="peer-focus:font-medium flex absolute text-sm font-medium  text-gray-500 duration-300 transform -translate-y-8 scale-75 top-3 -z-10 origin-[0] peer-focus:start-1 rtl:peer-focus:translate-x-1/4 peer-focus:text-red-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                            >{" "}Contraseña{" "}
                            </label>
                            <input
                              type={showPassword ? "text" : "password"}
                              name="contrasenia"
                              id="contrasenia"
                              minLength={8}
                              maxLength={12}
                              value={contactInfo.contrasenia}
                              onChange={handleChange}
                              className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 focus:outline-none focus:ring-1 focus:border-red-600 peer"
                              placeholder=" "
                              required
                            />{" "}

                            <button
                              type="button"
                              onClick={togglePasswordVisibility}
                              className="absolute right-0 top-3 px-2"
                            >
                              <box-icon
                                type="solid"
                                name={showPassword ? "show" : "hide"}
                                color="gray"
                              ></box-icon>
                            </button>
                          </div>
                          <div className="relative z-0 w-full mb-5 group">
                            <label
                              htmlFor="confirmPassword"
                              className="peer-focus:font-medium flex absolute text-sm font-medium text-gray-500 duration-300 transform -translate-y-8 scale-75 top-3 -z-10 origin-[0] peer-focus:start-1 rtl:peer-focus:translate-x-1/4 peer-focus:text-red-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                            >
                              {" "}Confirmar contraseña{" "}
                            </label>
                            <input
                              type={showPassword ? "text" : "password"}
                              name="confirmPassword"
                              id="confirmPassword"
                              minLength={8}
                              maxLength={12}
                              value={contactInfo.confirmPassword}
                              onChange={handleChange}
                              className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 focus:outline-none focus:ring-1 focus:border-red-600 peer"
                              placeholder=" "
                              required
                            />{" "}

                            <button
                              type="button"
                              onClick={togglePasswordVisibility}
                              className="absolute right-0 top-3 px-2"
                            >
                              <box-icon
                                type="solid"
                                name={showPassword ? "show" : "hide"}
                                color="gray"
                              ></box-icon>
                            </button>

                            {" "}
                            {!passwordsMatch && contactInfo.contrasenia && contactInfo.confirmPassword && (
                              <span className="text-red-500 text-xs">* Las contraseñas no coinciden, minimo 8 y maximo 12 caracteres</span>
                            )}

                          </div>

                          <button
                            type="submit"
                            className="w-full mt-2 text-white btn-rojo
                             hover:bg-[#494544] focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                            {" "}
                            Guardar{" "}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
      <div className="fixed bottom-0 left-0 right-0">
        <FooterTransparent></FooterTransparent>
      </div>
    </section>
  );
}
export default Newsletter;